import PropTypes from 'prop-types';

import classNames from 'classnames';
import styles from './FJGenerateQuantity.module.less';
import FJLocalStore from '../../../store/FJLocalStore';
import { IMAGE_NUMBER_LIST } from '../../../config/dataConfig/FJImageToImageData';
import FJDropdownNew from '../../../common/components/FJDropDown/FJDropdownNew.jsx';
import CheckIcon from '../../../assets/svg/choose.svg?react';
import FJToolTip from '../../../common/components/FJToolTip/FJToolTip.jsx';

const FJGenerateQuantity = props => {
    const { generateQuantity, handleChangeGenerateNumber } = props;

    const renderTrigger = ({ ref, onClick }) => {
        return (
            <FJToolTip title={'quantity'}>
                <div className={styles.icon_box} ref={ref} onClick={onClick}>
                    x {generateQuantity}
                </div>
            </FJToolTip>
        );
    };

    const renderOverlay = ({ ref }) => {
        return (
            <div ref={ref} className={styles.box}>
                <div className={styles.model_image_number_title}>{FJLocalStore._('quantity')}</div>

                <div className={styles.image_number_list_box}>
                    {IMAGE_NUMBER_LIST.map(item => {
                        return (
                            <div
                                className={classNames(
                                    styles.image_number_item,
                                    item.value == generateQuantity && styles.image_number_item_active,
                                )}
                                key={item.value}
                                onClick={() => handleChangeGenerateNumber(item.value)}
                            >
                                <div className={styles.image_number_item_text}>{item.text}</div>
                                {item.value == generateQuantity && <CheckIcon className={styles.check_icon} />}
                            </div>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <FJDropdownNew
            renderTrigger={renderTrigger}
            useAnchorBody
            placement='topCenter'
            trigger='click'
            isTopLayer={true}
            renderOverlay={renderOverlay}
            offsetTop={-4}
        />
    );
};

FJGenerateQuantity.propTypes = {
    generateQuantity: PropTypes.number,
    handleChangeGenerateNumber: PropTypes.func,
};
export default FJGenerateQuantity;
